import { Link } from "react-router-dom";
import { Card, PageHeader } from "@/components/ui";
import { useKnowledgeStatus, useLeads, useMe } from "@/lib/api";

export function OverviewScreen() {
  const me = useMe();
  const status = useKnowledgeStatus(true);
  const leads = useLeads();
  const s = status.data;
  const inProgress = s
    ? s.pages.queued +
      s.pages.processing +
      s.pages.indexing +
      s.documents.queued +
      s.documents.processing +
      s.documents.indexing +
      s.websitesDiscovering
    : 0;
  return (
    <>
      <PageHeader
        title={me.data?.organization.name ?? "Overview"}
        subtitle="Where things stand."
      />
      <div className="grid gap-4 sm:grid-cols-3">
        <Stat
          label="Pages read"
          value={s ? `${s.pages.ready}` : "…"}
          hint={s ? `${s.pages.failed} failed · ${inProgress} in progress` : ""}
        />
        <Stat
          label="Documents read"
          value={s ? `${s.documents.ready}` : "…"}
          hint={s ? `${s.documents.failed} failed` : ""}
        />
        <Stat
          label="Leads"
          value={
            leads.data
              ? `${leads.data.items.length}${leads.data.pagination.hasMore ? "+" : ""}`
              : "…"
          }
          hint="From the widget"
        />
      </div>
      <Card className="mt-6">
        <p className="font-semibold">Knowledge base</p>
        <p className="mt-1 text-[13px] text-muted">
          {s
            ? `${(s.totalBytes / 1024).toFixed(0)} KB of source material from your site and documents${s.knowledgeBaseConfigured ? "" : " (knowledge base not configured in this environment)"}.`
            : "…"}{" "}
          <Link to="/knowledge" className="text-accent">
            Manage
          </Link>{" "}
          ·{" "}
          <Link to="/install" className="text-accent">
            Install the widget
          </Link>
        </p>
      </Card>
    </>
  );
}

function Stat({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  hint: string;
}) {
  return (
    <Card>
      <p className="eyebrow">{label}</p>
      <p className="mt-1 text-[28px] font-bold tracking-[-0.03em]">{value}</p>
      <p className="text-[12px] text-muted">{hint}</p>
    </Card>
  );
}
